import { createDecorator } from '../../instantiation/common/instantiation.js';
const ILayoutService = ( createDecorator('layoutService'));
export { ILayoutService };
